import { useLang } from '@/i18n';
import EcoBarPromo from 'eco-design/sections-test/eco-bar-promo';
import style from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BarPromoA');

    return (
        <div className={style.comp}>
            <EcoBarPromo logo="https://websiteoss.ecoflow.com/upload/image/1744597105638/yhj-x.png" title={t('title')} />
        </div>
    );
}
